import { motion, AnimatePresence } from "framer-motion";
import React, {useState } from "react";
import GlassSurface from "../common/GlassSurface";
import { useCursor } from "../cursor/useCursor";
import { CURSORS } from "../cursor/cursors";
import { Link } from 'react-router-dom'
import v1Cover from "../../../assets/images/v1_cover.png"

const navItems = [
  { label: "Home", id: "home", rotation: -6, hoverBg: "#3b82f6" },
  { label: "Experience", id: "experience", rotation: 5, hoverBg: "#10b981" },
  { label: "Projects", id: "projects", rotation: -5, hoverBg: "#f59e0b" },
  { label: "Contact", id: "contact", rotation: 6, hoverBg: "#8b5cf6" }
];

function FloatingDock({ activeSection, showDock ,setIsNavigating}) {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {cursor} = useCursor()

  const bubblePositions = [
  {
    left: 8,
    bottom: 30,
    rotate: 8,
  },
  {
    left: 48,
    bottom: 30,
    rotate: -6,
  },
  {
    left: 15,
    bottom: 18,
    rotate: -5,
  },
  {
    left: 62,
    bottom: 15,
    rotate: 8,
  },
];

  const scrollToSection = (id) => {

  setIsNavigating(true);
  setIsMenuOpen(false)

  const target = document.getElementById(id);

  if (!target) {
    setIsNavigating(false);
    return;
  }

  target.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });

  let lastY = window.scrollY;
  let stableFrames = 0;

  const checkScroll = () => {

    const currentY = window.scrollY;

    if (Math.abs(currentY - lastY) < 1) {
      stableFrames++;
    } else {
      stableFrames = 0;
    }

    lastY = currentY;

    // Scroll position stayed almost unchanged
    // for several frames → scrolling finished
    if (stableFrames >= 8) {
      setIsNavigating(false);
      return;
    }

    requestAnimationFrame(checkScroll);
  };

  requestAnimationFrame(checkScroll);
  };

  return (
    <>
      {/* ================= DESKTOP / TABLET ================= */}

      <motion.div
      {...cursor({...CURSORS.default,background:"#fff",blendMode:"difference",border:"1px solid #fff"})}
        animate={{ x: "-50%", y: showDock ? 0 : 120, opacity: showDock ? 1 : 0, scale: showDock ? 1 : 0.5 }}
        transition={{ type: "spring", stiffness: 320, damping: 20, mass: 1 }}
        className="hidden md:block fixed bottom-5 left-1/2 z-50 text-white"
      >
        <GlassSurface
          width={780}
          height={97}
          borderRadius={35}
          backgroundOpacity={0.34}
          blur={9}
          displace={2.8}
          borderWidth={0}
          distortionScale={90}
          className="shadow-[0_30px_80px_rgba(0,0,0,.4)]"
        >
          <div className="px-3 py-3 flex items-center justify-around h-24 w-full">

            {/* LOGO */}

            <div className="w-52">
              <img src="/badusha.svg" alt="" className="w-full h-auto" />
            </div>

            {/* NAVIGATION */}

            <div className="flex justify-center gap-7 w-full">

              {navItems.map((item, index) => (
                <div
                  key={item.id}
                  className="relative px-2 py-2 cursor-pointer"
                  onClick={() => scrollToSection(item.id)}
                  onMouseEnter={() => setHoveredItem(item.id)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <h1 key={index}>
                    {item.label}
                  </h1>

                  {/* ACTIVE DOT */}

                  {activeSection === item.id && (
                    <motion.div
                      layoutId="active-dot"
                      className="absolute left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-green-400"
                      transition={{ type: "spring", stiffness: 450, damping: 30 }}
                    />
                  )}

                  {/* HOVER DOT */}

                  {hoveredItem === item.id && activeSection !== item.id && (
                    <motion.div
                      initial={{ scale: 0, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0, opacity: 0 }}
                      className="absolute left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-white"
                    />
                  )}
                </div>
              ))}

            </div>

            {/* GREEN BLOCK */}
            
              <Link to='v1'>
                <div 
                {...cursor({...CURSORS.default,background:"#000",blendMode:"normal",text:'v1',size:40,color:"#fff"})}
                className="w-28 h-[4.2rem] flex items-center justify-center overflow-hidden rounded-3xl bg-[#CFEF00]" >
                <img src={v1Cover} alt="" />
             

                {/* <h1 className="text-black/70 text">
                  version 1
                  </h1> */}
                </div>
                  </Link>

          </div>
        </GlassSurface>
      </motion.div>

      {/* ================= MOBILE BAR ================= */}

      <motion.div
        animate={{ x: "-50%", y: showDock ? 0 : 120, opacity: showDock ? 1 : 0, scale: showDock ? 1 : 0.5 }}
        transition={{ type: "spring", stiffness: 320, damping: 20, mass: 1 }}
        className="md:hidden fixed bottom-5 left-1/2 z-50 text-white w-[92vw] max-w-sm"
      >
        <GlassSurface
          width="100%"
          height={64}
          borderRadius={28}
          backgroundOpacity={0.34}
          blur={9}
          displace={2.8}
          borderWidth={0}
          distortionScale={90}
          className="shadow-[0_30px_80px_rgba(0,0,0,.4)]"
        >
          <div className="grid grid-cols-3 items-center w-full h-full px-2">

            {/* GREEN BLOCK */}

            <Link to='v1'>
                <div 
                {...cursor({...CURSORS.default,background:"#000",blendMode:"normal",text:'v1',size:40,color:"#fff"})}
                className="w-20 h-[3rem] flex items-center justify-center overflow-hidden rounded-3xl bg-[#CFEF00]" >
                <img src={v1Cover} alt="" />
             

                {/* <h1 className="text-black/70 text">
                  version 1
                  </h1> */}
                </div>
                  </Link>

            {/* LOGO */}

            <div className="justify-self-center w-24">
              <img src="/badusha.svg" alt="" className="w-full h-auto" />
            </div>

            {/* MENU BUTTON */}

            <button
              type="button"
              aria-label="Toggle menu"
              aria-pressed={isMenuOpen}
              onClick={() => setIsMenuOpen((v) => !v)}
              className="justify-self-end flex flex-col items-center justify-center w-11 h-11 rounded-full bg-white/10"
            >
              <span
                className="block w-5 h-[2px] bg-white rounded-full transition-transform duration-300"
                style={{
                  transform: isMenuOpen
                    ? "translateY(3px) rotate(45deg)"
                    : "none"
                }}
              />

              <span
                className="block w-5 h-[2px] bg-white rounded-full mt-1.5 transition-transform duration-300"
                style={{
                  transform: isMenuOpen
                    ? "translateY(-3px) rotate(-45deg)"
                    : "none"
                }}
              />
            </button>

          </div>
        </GlassSurface>
      </motion.div>

      {/* ================= MOBILE BUBBLE MENU ================= */}

      <AnimatePresence>
        {isMenuOpen && (
          <>
            {/* TAP OUTSIDE */}

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="md:hidden fixed inset-0 z-40"
              onClick={() => setIsMenuOpen(false)}
            />


          <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="md:hidden fixed inset-0 z-40 bg-black/45 pointer-events-none"
      />
            
            {/* BUBBLES */}
            <div
              className="md:hidden fixed inset-0 z-40 px-6 pointer-events-none"
            >
              {navItems.map((item, i) => (
                <motion.button
                  key={item.id}
                  type="button"
                  onClick={() => scrollToSection(item.id)}
                  initial={{ scale: 0, opacity: 0, y: 60, rotate: 0 }}
                  animate={{
                    scale: 1,
                    opacity: 1,
                    y: 0,
                    rotate: bubblePositions[i]?.rotate ?? 0
                  }}
                  exit={{ scale: 0, opacity: 0, y: 60 }}
                  transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 20,
                    delay: i * 0.06
                  }}
                  style={{
                    
                    position: "absolute",
                    left: `${bubblePositions[i]?.left ?? 50}%`,
                    bottom: `${bubblePositions[i]?.bottom ?? 30}%`,
                    transformOrigin: "bottom center",
                    backgroundColor:
                      activeSection === item.id ? item.hoverBg : "#fff",
                    color:
                      activeSection === item.id ? "#fff" : "#000"
                  }}
                  className="pointer-events-auto px-8 py-4 rounded-full text-lg font-medium text-center shadow-[0_12px_32px_rgba(0,0,0,0.35)] whitespace-nowrap transition-colors"
                >
                  {item.label}
                </motion.button>
              ))}
            </div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}

export default FloatingDock;